/**
 * Green Flag — EventArrivalSection
 *
 * The event page's "Before you go" section for an attendee: how to find the
 * group and where to park, from their registration.
 */

import { Box, Heading } from "@chakra-ui/react";
import { SparkArrivalInfo } from "@greenflagdate/shared";
import { EventArrivalInfo } from "../EventArrivalInfo/EventArrivalInfo";

export interface EventArrivalSectionProps {
  arrival: SparkArrivalInfo;
}

export function EventArrivalSection({ arrival }: EventArrivalSectionProps) {
  return (
    <Box as="section" mt="1.5rem" maxW="28rem" mx="auto">
      <Heading as="h2" textStyle="sectionTitle" mb="0.875rem">
        Before you go
      </Heading>
      <EventArrivalInfo arrival={arrival} />
    </Box>
  );
}
